export default __webpack_public_path__ + "static/media/Ranger.ad122897.jpg";